<template>
  <div id="login-container">
    <router-view />
    <div id="logo">
      <router-link to="/index">
        <img src="../../assets/img/logo.png" alt="" />
      </router-link>
    </div>
    <div id="denglu">
      <img src="../../assets/img/chongzmima.png" alt="" />
    </div>
    <div id="login-box">
      <div class="progressBar">
        <ul class="written">
          <li class="se">填写手机</li>
          <li class="se">验证身份</li>
          <li class="se">设置新密码</li>
          <li class="hou">完成</li>
        </ul>
        <div class="bian"></div>
        <div class="strip"></div>
        <ul class="chart">
          <li class="se"></li>
          <li class="se"></li>
          <li class="se"></li>
          <li class="hou"></li>
        </ul>
        <img class="bian" src="../../assets/img/wancheng3.png" alt="" />
        <img class="aircraft" src="../../assets/img/fly icon2.png" alt="" />
      </div>
      <el-form ref="passForm" :model="passForm" :rules="passRules">
        <el-form-item prop="pass" label-width="100px">
          <b class="icon-user">密码：</b>
          <el-input
            v-model="passForm.pass"
            placeholder="请输入密码"
            class="username-style"
            show-password
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="checkPass" label-width="100px">
          <b class="icon-pass">确认密码：</b>
          <el-input
            v-model="passForm.checkPass"
            placeholder="请输入密码"
            class="password-style"
            show-password
          >
          </el-input>
        </el-form-item>

        <el-form-item size="large" class="login-but">
          <el-button type="primary" @click="xiayibu()">下一步</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="return" @click="onReturn()">
      <span>返回登陆</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error("请输入密码"));
    //   } else {
    //     callback();
    //   }
    // };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.passForm.pass !== this.passForm.checkPass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      // 表单校验规则定义
      passRules: {
        pass: [
          { required: true, message: "密码必填", trigger: "blur" },
          { min: 6, max: 20, message: "不小于六位", trigger: "blur" }
        ],
        checkPass: [{ validator: validatePass, trigger: "blur" }]
      },
      // form表单数据对象
      passForm: {
        pass: "",
        checkPass: ""
      },
      checkPass: { password: "", username: "" }
    };
  },
  created() {
    this.getRouterData();
  },
  methods: {
    getRouterData() {
      this.checkPass.username = this.$route.query.username;
    },
    // 返回登录事件
    onReturn() {
      this.$router.push("/login");
    },
    xiayibu() {
      // console.log(this.passForm.checkPass.password);
      this.checkPass.password = this.passForm.checkPass;
      this.$refs.passForm.validate(async valid => {
        if (valid === true) {
          var { data: dt } = await this.$http.post(
            "user/updatePassword",
            this.checkPass
          );
          // console.log(dt);
        }
        if (dt.status !== 200) {
          return this.$message.error(dt.msg);
        }
        this.$router.push("/complete");
      });
    }
  }
};
</script>

<style lang="less" scoped>
#login-container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url(../../assets/img/beijing10.png);
  // z-index: -10;
  overflow: auto;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;

  #logo {
    margin-top: 40px;
    margin-left: 40px;
    margin-bottom: 60px;
    overflow: hidden;
  }

  #denglu {
    width: 235px;
    height: 55px;
    display: block;
    margin: 0 auto;
  }

  #login-box {
    position: absolute;
    width: 520px;
    height: 480px;
    background-color: #fff;
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 50px;
    // margin-left: 700px;
    position: relative;
    .el-input {
      width: 320px;
      height: 40px;
    }
    .username-style {
      margin-top: 115px;
      // margin-left: 100px;
    }
    .password-style {
      margin-top: 20px;
      // margin-left: 100px;
    }
    .icon-user {
      position: absolute;
      left: 0;
      top: 0;
      margin-top: 150px;
      // margin-left: 100px;
      font-size: 14px;
    }
    .icon-pass {
      position: absolute;
      left: 0;
      top: 0;
      margin-top: -10px;
      // margin-left: 100px;
      font-size: 14px;
    }
    .el-button {
      width: 320px;
      height: 50px;
    }
    .login-but {
      position: absolute;
      bottom: 0;
      right: 0;
      margin-bottom: 60px;
      margin-right: 100px;
    }
    .Grap-style {
      width: 200px;
      height: 40px;
      margin-top: 20px;
    }
    .yztupian {
      position: absolute;
      right: 100px;
      top: 20px;
      cursor: pointer;
    }
    .progressBar .written {
      width: 100%;
      margin: 0 auto;
      li {
        list-style-type: none;
        float: left;
        margin-right: 55px;
        text-align: center;
        color: #a9acbb;
        margin-top: 45px;
        overflow: hidden;
        font-weight: 550;
      }
      .se {
        color: #0086fd;
      }
      .hou {
        margin-right: 0px;
      }
      // li:last-child {
      //   margin-right: 0px;
      // }
    }
    .progressBar .chart {
      list-style-type: none;
      position: absolute;
      top: 65px;
      left: 10px;

      li {
        float: left;
        width: 45px;
        height: 45px;
        background: #eff0f4;

        border-radius: 50%;
        margin-right: 73px;
      }
      .se {
        box-shadow: 0px 0px 18px 2px rgba(0, 134, 253, 0.2);
        background: #0086fd;
      }

      .hou {
        margin-right: 0px;
      }
    }
    .strip {
      width: 335px;
      height: 15px;
      background-color: #eff0f4;
      position: absolute;
      top: 95px;
      left: 93px;
    }
    .bian {
      position: absolute;
      top: 95px;
      left: 90px;
    }
    .aircraft {
      position: absolute;
      top: 85px;
      left: 350px;
    }
  }
}
.return {
  width: 140px;
  height: 50px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 6px;
  line-height: 50px;
  position: absolute;
  top: 30px;
  right: 35px;
  cursor: pointer;
  span {
    display: block;
    width: 70px;
    margin: 0 auto;
    color: rgba(255, 255, 255, 1);
  }
}
</style>
